import { all, fork, put, takeEvery } from 'redux-saga/effects';
import * as types from './types';
import * as Api from '../../api/publicTemplates';
import callToAPI from '../../../utils/callToAPI';
import PublicTemplate from '../../../models/Template';

function* getPublicTemplates({ payload }) {
  yield callToAPI({
    apiCall: Api.getPublicTemplates,
    successResponseCode: 200,
    errorType: types.GET_PUBLIC_TEMPLATES_ERROR,
    *callback({ data }) {
      yield put({
        type: types.GET_PUBLIC_TEMPLATES_SUCCESS,
        payload: {
          publicTemplates: data.data.map((publicTemplate) => {
            return new PublicTemplate(publicTemplate);
          }),
          total: data.total,
        },
      });
    },
    payload,
  });
}

function* updatePublicTemplate({ payload }) {
  yield callToAPI({
    apiCall: Api.updatePublicTemplate,
    successResponseCode: 200,
    errorType: types.UPDATE_PUBLIC_TEMPLATE_ERROR,
    *callback(response) {
      yield put({
        type: types.UPDATE_PUBLIC_TEMPLATE_SUCCESS,
        payload: new PublicTemplate(response.data),
      });
    },
    payload,
  });
}

function* createPublicTemplate({ payload }) {
  yield callToAPI({
    apiCall: Api.createPublicTemplate,
    successResponseCode: 200,
    errorType: types.CREATE_PUBLIC_TEMPLATE_ERROR,
    *callback(response) {
      yield put({
        type: types.CREATE_PUBLIC_TEMPLATE_SUCCESS,
        payload: new PublicTemplate(response.data),
      });
    },
    payload,
  });
}

function* deletePublicTemplate({ payload }) {
  yield callToAPI({
    apiCall: Api.deletePublicTemplate,
    successResponseCode: 200,
    errorType: types.DELETE_PUBLIC_TEMPLATE_ERROR,
    *callback() {
      yield put({ type: types.DELETE_PUBLIC_TEMPLATE_SUCCESS, payload });
    },
    payload,
  });
}

function* copyPublicTemplate({ payload }) {
  yield callToAPI({
    apiCall: Api.copyPublicTemplate,
    successResponseCode: 201,
    errorType: types.COPY_PUBLIC_TEMPLATE_ERROR,
    *callback() {
      yield put({ type: types.COPY_PUBLIC_TEMPLATE_SUCCESS });
    },
    payload,
  });
}

/* watchers */
function* watcherUpdatePublicTemplate() {
  yield takeEvery(types.UPDATE_PUBLIC_TEMPLATE_REQUEST, updatePublicTemplate);
}

function* watcherGetPublicTemplates() {
  yield takeEvery(types.GET_PUBLIC_TEMPLATES_REQUEST, getPublicTemplates);
}

function* watcherCreatePublicTemplate() {
  yield takeEvery(types.CREATE_PUBLIC_TEMPLATE_REQUEST, createPublicTemplate);
}

function* watcherDeletePublicTemplate() {
  yield takeEvery(types.DELETE_PUBLIC_TEMPLATE_REQUEST, deletePublicTemplate);
}

function* watcherCopyPublicTemplate() {
  yield takeEvery(types.COPY_PUBLIC_TEMPLATE_REQUEST, copyPublicTemplate);
}

export default function* rootSaga() {
  yield all([
    fork(watcherUpdatePublicTemplate),
    fork(watcherGetPublicTemplates),
    fork(watcherCreatePublicTemplate),
    fork(watcherDeletePublicTemplate),
    fork(watcherCopyPublicTemplate),
  ]);
}
